import axios from 'axios'
import { Message } from 'element-ui'

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
})

// 监护统计接口双鉴权：优先 Web 后台登录令牌（ems_web_token），未登录后台时回退小程序令牌（ems_mp_admin_token）。
// 与报修（api/repair.js）同一套写法：用请求拦截器在每次调用时动态取值，
// 后台登录后无需刷新页面即可访问监护统计页。注意：utils/request 的通用实例只带 Web Token，用它访问会 403。
api.interceptors.request.use(config => {
  const webToken = localStorage.getItem('ems_web_token')
  const mpToken = localStorage.getItem('ems_mp_admin_token')
  const token = webToken || mpToken
  if (token) {
    config.headers['Authorization'] = 'Token ' + token
  } else {
    delete config.headers['Authorization']
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    if (!status) {
      // 网络不通：请求根本没有 HTTP 响应（断网 / 超时 / DNS 失败 / 跨域被拦）
      Message.closeAll()
      Message.warning('网络无法连接后端，请检查网络或稍后重试')
    } else if (status >= 500) {
      // 服务器内部错误，与网络无关，不应误报成"未连接"
      Message.closeAll()
      Message.error('服务器异常（HTTP 500），请稍后重试或联系管理员')
    } else if (status === 403) {
      Message.error('无权限：请先登录后台账号，或在「设置令牌」中粘贴小程序后勤/管理员令牌')
    }
    return Promise.reject(error)
  }
)

export default {
  // 日报图片 OCR 预览：识别各科室监护人次，返回可编辑预览（不写库）
  // formData 含字段 file（图片）
  previewImage(formData) {
    return api.post('/monitor-stat/preview/', formData)
  },
  // 核对后入库：{ stat_date?, rows: [{ department, monitor_person_times }] }
  confirmRows(data) {
    return api.post('/monitor-stat/confirm/', data)
  },
  // 上传监护仪设备清单 xlsx：formData 含字段 file（可选 stat_date 指定落库日期）
  uploadExcel(formData) {
    return api.post('/monitor-stat/excel/', formData)
  },
  // 大屏数据（GET）
  getDashboard() {
    return api.get('/monitor-stat/dashboard/')
  },

  // ===== 历史留存（2026-10-24 新增）=====
  // 历史明细：{ start_date, end_date, department, page, page_size }
  getHistory(params) {
    return api.get('/monitor-stat/history/', { params })
  },
  // 区间汇总：{ start_date, end_date, department, group_by: day|month|department }
  getSummary(params) {
    return api.get('/monitor-stat/summary/', { params })
  },
  // 导出 Excel（后端返回二进制，必须加 responseType: 'blob'）
  exportHistory(params) {
    return api.get('/monitor-stat/export/', { params, responseType: 'blob' })
  },
  // 历史数据里出现过的科室（是「合并显示名」，与科室字典不同，不能复用 department 接口）
  getDeptOptions() {
    return api.get('/monitor-stat/departments/')
  },
  // 日报原图留档列表：{ start_date, end_date, page, page_size }
  listFiles(params) {
    return api.get('/monitor-stat/files/', { params })
  },
  // 单张原图详情（含 OCR 原始文本）
  getFile(id) {
    return api.get(`/monitor-stat/file/${id}/`)
  },
}
